import PageLayout from "../layout/PageLayout";
import UsersEditor from "../components/UsersEditor";
import React from "react";

export default function Users(){
  return <PageLayout pageTitle="Utenti">
    <UsersEditor sx={{ pt: 2, width: 1, maxWidth: '500px' }} />
  </PageLayout>
}